// extracted by mini-css-extract-plugin
export var marquee = "marquee-v2-module--marquee--acb92";
export var marqueeDefault = "marquee-v2-module--marquee-default--5b5d7";
export var marqueeReverse = "marquee-v2-module--marquee-reverse--274c8";
export var marquee__elements = "marquee-v2-module--marquee__elements--95838";
export var marquee__measure = "marquee-v2-module--marquee__measure--db34d";
export var marquee__overflow = "marquee-v2-module--marquee__overflow--e0cd5";
export var marquee__spacer = "marquee-v2-module--marquee__spacer--b7a8c";
export var reversed = "marquee-v2-module--reversed--898f8";